module.exports = __webpack_public_path__ + "static/media/nft-16.2f6372f5.jpg";